export const GRID_D12__T12 = "grid__d12__t12";
export const GRID_D2_10__T2_10 = "grid__d2-10__t2-10";
export const GRID_D10_2__T10_2 = "grid__d10-2__t10-2";
export const GRID_D9_3__T8_4 = "grid__d9-3__t8-4";
export const GRID_D3_9__T4_8 = "grid__d3-9__t4-8";
export const GRID_D8_4__T8_4 = "grid__d8-4__t8-4";
export const GRID_D4_8__T4_8 = "grid__d4-8__t4-8";
export const GRID_D6_6__T6_6 = "grid__d6-6__t6-6";
export const GRID_D6_3_3__T12_6_6 = "grid__d6-3-3__t12-6-6";
export const GRID_D3_3_6__T6_6_12 = "grid__d3-3-6__t6-6-12";
export const GRID_D4_4_4__T4_4_4 = "grid__d4-4-4__t4-4-4";
export const GRID_D3_3_3_3__T6_6_6_6 = "grid__d3-3-3-3__t6-6-6-6";
export const GRID_D3_3_3_3__T12 = "grid__d3-3-3-3__t12";
export const GRID_D4_4_4__T12 = "grid__d4-4-4__t12";
export const GRID_D2_2_2_2_2_2__T12 = "grid__d2-2-2-2-2-2__t12";
export const GRID_D2_8_2 = "grid__d2-8-2";
export const GRID_D2_5_5 = "grid__d2-5-5";
export const GRID_D3_6_3__T2_8_2 = "grid__d3-6-3__t2-8-2";
export const GRID_D5_5_2 = "grid__d5-5-2";
export const GRID_D2_4_4_2__T6_6_6_6 = "grid__d2-4-4-2__t6-6-6-6";
export const GRID_D2_2_2_2_2_2__T6_6 = "grid__d2-2-2-2-2-2__t6-6";

export const GRIDS = [
  GRID_D12__T12,
  GRID_D2_10__T2_10,
  GRID_D3_9__T4_8,
  GRID_D4_8__T4_8,
  GRID_D6_6__T6_6,
  GRID_D8_4__T8_4,
  GRID_D9_3__T8_4,
  GRID_D10_2__T10_2,
  GRID_D2_5_5,
  GRID_D2_8_2,
  GRID_D3_3_6__T6_6_12,
  GRID_D3_6_3__T2_8_2,
  GRID_D4_4_4__T4_4_4,
  GRID_D5_5_2,
  GRID_D6_3_3__T12_6_6,
  GRID_D2_4_4_2__T6_6_6_6,
  GRID_D3_3_3_3__T6_6_6_6,
  GRID_D2_2_2_2_2_2__T6_6,
  GRID_D2_2_2_2_2_2__T12,
  GRID_D3_3_3_3__T12,
  GRID_D4_4_4__T12
] as const;

export const CONTENT_POSITION_TOP = "top";
export const CONTENT_POSITION_CENTER = "center";
export const CONTENT_POSITION_BOTTOM = "bottom";

export const CONTENT_POSITIONS = [CONTENT_POSITION_TOP, CONTENT_POSITION_CENTER, CONTENT_POSITION_BOTTOM] as const;
